export default class InfiniteScroll {
  constructor() {
    this.valid = true;

    this.content = [];
    this.lazy = [];

    this.projectOffset = window.scrollY || 0;
    this.lastScroll = window.scrollY || 0;
    this.loopHeight = 0;

   
    this.headerHeight = (window.innerWidth * 0.22406);
    
    this.scrollWrapper = document.querySelector('.project-scroll-wrapper');
    this.scrollContent = document.querySelector('.project-list');
    this.header = document.querySelector('header');
    this.logo = document.querySelector('#logo-wrap');

    if(!this.scrollContent){
       this.valid = false;
       return;
    }

    this.translateStart = 0;
    this.scrollStart = 0;

    this.boundMouseover = this.handleMouseover.bind(this);

    this.lastScrollTime = performance.now();
    this.bodyResetTimeout = null;
    this.scrollCheckInterval = null;
    this.originalBodyHeight = document.body.scrollHeight;
    this.skip = false;


    if (!this.scrollWrapper || !this.scrollContent || !this.header || document.querySelector('.index')) {
      document.body.classList.remove('loop-scroll');
      this.valid = false;
      return;
    }

    this.scrollCheckInterval = setInterval(() => {
     this.checkIt();
    }, 250);

    this.curCont = 0;
    this.content = this.scrollContent.querySelectorAll('.project.og');

    this.boundScroll = this.handleScroll.bind(this);
    this.init();
  }

  checkIt() {
  const now = performance.now();
  const idleFor = now - this.lastScrollTime;


  if (idleFor > 200 && window.scrollY > this.headerHeight &&  document.body.style.height !== `${this.originalBodyHeight}px`) {

    this.skip = true;
    document.body.style.height = `${this.originalBodyHeight}px`;

    // Recalculate offset
    const targetScroll = this.headerHeight + this.projectOffset;

    setTimeout(() => {
      // Reset scroll position
      if(window.scrollingToSomething) return;
      window.scrollTo({ top: targetScroll });

      // Sync transform and offsets so it's perfectly aligned
      this.lastScroll = targetScroll;
      this.scrollStart = targetScroll;
      this.projectOffset = targetScroll - this.headerHeight;
      this.translateStart = this.projectOffset;

      // Apply transform immediately
      this.updateTranslate();

      // console.log('Sync:', {
      //   headerHeight: this.headerHeight,
      //   projectOffset: this.projectOffset,
      //   scrollY: window.scrollY,
      // });

    }, 10);
  }
}


  init() {

    this.measureLoopHeight();

    // Clone enough to allow looping space — at least 2x loopHeight
    const desiredCloneHeight = this.loopHeight * 2;
    while (this.scrollContent.offsetHeight < desiredCloneHeight) {
      this.addClone();
    }

    document.body.classList.add('loop-scroll');

    this.lazy = this.scrollContent.querySelectorAll('.lazy');
    for (let i = 0; i < this.lazy.length; i++) {
      this.loadAsset(this.lazy[i], i);
    }

    for (let project of this.content) {
    project.addEventListener('mouseover', this.boundMouseover);
      this.bindLink(project);
    }
    
   
    this.updateTranslate();

    this.headerHeight = (window.innerWidth * 0.22406);
    window.addEventListener('scroll', this.boundScroll);
  }

  handleScroll() {

    this.lastScrollTime = performance.now(); // 👈 track scroll activity

    const scrollY = window.scrollY;
    const currentBodyHeight = document.body.scrollHeight;

    // Expand body height if near bottom
    if (scrollY + window.innerHeight > currentBodyHeight - 500) {
      document.body.style.height = `${currentBodyHeight + 1000}px`;
    }

    const top = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);
    
    if(top > 0){
      const scrollY = top;
    }else{
       const scrollY = 0;
    }
    let delta = Math.round(scrollY - this.lastScroll);
  
    if (isNaN(delta)) {
      delta = 0;
    }


    let dir = delta >= 0;

    if(this.skip){}
    
    this.projectOffset += delta;
    const pageMaxScroll = document.documentElement.scrollHeight - window.innerHeight;

    const test = (window.innerWidth * .2227) + 200;

    if (this.projectOffset > this.loopHeight+test) {
      this.projectOffset -= this.loopHeight;
    }

    // if (scrollY > pageMaxScroll - 5) {
    //   this.lastScroll = this.headerHeight;
    // } else {
      this.lastScroll = scrollY;
    // }



    if (!dir) {

      const scrollProgress = Math.max(0, Math.min(1, scrollY / this.scrollStart));
      this.projectOffset = (this.translateStart * scrollProgress);

      if (Math.abs(this.projectOffset) < 1 && scrollY < 10) {
        this.projectOffset = 0;
      }

    }else{

      this.translateStart = this.projectOffset;
      this.scrollStart = scrollY;

    }


    if(top === 0){
      this.projectOffset = 0; 
    }

    this.updateTranslate();
    this.measureLoopHeight();

  }

  updateTranslate() {
    if(!this.skip){
      this.scrollWrapper.style.transform = `translateY(${-this.projectOffset}px)`;
    }else{
      this.skip = false;
    }
  }

  measureLoopHeight() {

    this.loopHeight = 0;

    this.scrollContent.querySelectorAll('.project.og').forEach(el => {
      this.loopHeight += el.offsetHeight;
    });

     this.headerHeight = (window.innerWidth * 0.22406);

  }
addClone() {

  const toClone = this.content[this.curCont]; // Only reference .og elements
  const clone = toClone.cloneNode(true);

  clone.classList.remove('og');
  clone.classList.add('clone');

  const embed = clone.querySelector('.video-embed');
  const embedWrap = clone.querySelector('.embed-wrap');
  if (embed) {
    embed.innerHTML = '';
    embed.dataset.vimeoInitialized = false;
    embed.removeAttribute('data-vimeo-initialized');
    embedWrap?.classList.remove('embed-loaded', 'playing');
    embedWrap?.classList.add('muted');
    embed.classList.remove('bound');
  }

  const links = clone.querySelectorAll('.bound');
  for (let link of links) {
    link.classList.remove('bound');
  }

  this.scrollContent.appendChild(clone);
  clone.offsetHeight; // force reflow

  const lazyItems = clone.querySelectorAll('.lazy');
  for (let item of lazyItems) {
    this.loadAsset(item, 0);
  }

  if (clone.querySelector('.mini-lazy')) {
    clone.addEventListener('mouseover', this.handleMouseover);
  }

  this.bindLink(clone);

  this.curCont++;
  if (this.curCont >= this.content.length) {
    this.curCont = 0;
  }
}


  handleMouseover(e) {
    const project = e.currentTarget;
    const minis = project.querySelectorAll('.mini-lazy');
    for (let asset of minis) {
      asset.src = asset.dataset.src;
      asset.classList.remove('mini-lazy');
    }
  }

  loadAsset(asset, i) {
    const url = asset.dataset.src;
    const project = asset.closest('.project');

    asset.onload = () => {
      asset.classList.remove('lazy');
      project.classList.add('loaded');
    };

    asset.src = url;

    if (i < this.lazy.length - 1) {
      i++;
      setTimeout(() => this.loadAsset(this.lazy[i], i), 10);
    }
  }

  bindLink(elm) {
    // if (window.touch) {

    //   const firstAsset = elm.querySelector('.first-asset');
    //   const link = firstAsset ? firstAsset.querySelector('a') : null;

    //   const handler = (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     if (elm.classList.contains('hovering')) {
    //       this.stopTouch(elm);
    //     } else {
    //       this.startTouch(elm);
    //     }
    //   };

    //   if (link) {
    //     link.addEventListener('click', handler);
    //   } else {
    //     elm.addEventListener('click', handler);
    //   }
    // }
  }

  startTouch(elm) {
    const minis = elm.querySelectorAll('.mini-lazy');
    for (let asset of minis) {
      asset.src = asset.dataset.src;
      asset.classList.remove('mini-lazy');
    }
    elm.classList.add('hovering');
  }

  stopTouch(elm) {
    elm.classList.remove('hovering');
  }

  
  // InfiniteScroll.js - Improved destroy method
  destroy() {
    // Clear all intervals and timeouts first
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
      this.scrollCheckInterval = null;
    }
    
    if (this.bodyResetTimeout) {
      clearTimeout(this.bodyResetTimeout);
      this.bodyResetTimeout = null;
    }
    
    // Remove event listeners
    window.removeEventListener('scroll', this.boundScroll);
    
    // Clean up DOM
    document.body.classList.remove('loop-scroll');
    document.body.style.height = '';
    
    if (this.scrollWrapper) {
      this.scrollWrapper.style.transform = '';
    }
    
    // Remove clones
    const clones = this.scrollContent?.querySelectorAll('.project.clone');
    clones?.forEach(clone => {
      // Clean up video elements before removing
      const videos = clone.querySelectorAll('video');
      videos.forEach(video => {
        video.pause();
        video.src = '';
        video.load();
      });
      clone.remove();
    });
    
    // Clean up event listeners on original projects
    if (this.content) {
      for (let project of this.content) {
        project.removeEventListener('mouseover', this.boundMouseover);
      }
    }
    
    // Clear references
    this.content = null;
    this.lazy = null;
    this.scrollContent = null;
    this.scrollWrapper = null;
    this.header = null;
    this.logo = null;
    
    this.valid = false;
  }

}
